import { render } from "./QrcodeScreen.vue?vue&type=template&id=886d8c50&scoped=true"
import script from "./QrcodeScreen.vue?vue&type=script&lang=js"
export * from "./QrcodeScreen.vue?vue&type=script&lang=js"

import "./QrcodeScreen.vue?vue&type=style&index=0&id=886d8c50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-886d8c50"]])

export default __exports__